export function forecastView(f, { canManage, today } = {}) {
  if (!f) return { kind: 'missing', lines: [] };
  if (f.busy) return { kind: 'busy', message: f.message, lines: [] };
  if (f.shadow && !canManage) return { kind: 'missing', lines: [], hidden: true };
  const fresh = Boolean(f.fresh);
  const common = {
    runAt: f.runAt ?? null, forDate: f.forDate ?? null, fresh, previewAt: f.previewAt ?? null,
    balanceCents: f.baseBalance?.baseCents ?? null, balanceAsOf: f.baseBalance?.asOf ?? null, stale: Boolean(f.baseBalance?.stale),
    lines: f.breakdown?.lines ?? [],
    startCents: f.breakdown?.baseCents ?? null,
    projectedCents: f.breakdown?.projectedCents ?? null,
    bufferCents: f.breakdown?.bufferCents ?? null,
    ...(f.shadow ? { shadow: true } : {}),
  };
  if (!fresh && today != null && f.forDate != null && f.forDate <= today) {
    return { kind: 'pending', ...common, lines: [], balanceCents: null, balanceAsOf: null, startCents: null };
  }
  if (f.status === 'no_figure') return { kind: 'none', reason: f.reason, ...common };
  if (Number(f.depositCents) > 0) return { kind: 'deposit', cents: Number(f.depositCents), ...common };
  return { kind: 'surplus', cents: Number(f.extraCents || 0), ...common };
}

export function whatIf(view, setAsideCents) {
  if (!view || (view.kind !== 'deposit' && view.kind !== 'surplus')) return null;
  if (!Number.isFinite(view.projectedCents) || !Number.isFinite(view.bufferCents)) return null;
  const shortBy = view.bufferCents - (view.projectedCents + setAsideCents);
  if (shortBy > 0) return { kind: 'deposit', cents: Math.ceil(shortBy / 1000) * 1000 };
  return { kind: 'surplus', cents: Math.floor(-shortBy / 100) * 100 || 0 };
}
